import './toast.scss';

import { CToast, CToastBody, CToastHeader } from '@coreui/react';
import classNames from 'classnames';
import React from 'react';

import { NotificationType } from '../../../constants/notification';

export interface IToastProps {
  children: any;
  show?: boolean;
  title?: string;
  showCloseButton?: boolean;
  autohide?: boolean | number;
  fade?: boolean;
  className?: string;
  type?: NotificationType;
  [key: string]: any;
}

export const Toast: React.FunctionComponent<IToastProps> = ({
  children, title, show = true, fade = true, className = '', showCloseButton = true,
  type = NotificationType.Success, autohide = 5000, ...props
}) => {
  const classes = classNames({
    [className]: true,
    [`toast-${type}`]: true,
  });
  return (
    <CToast
      fade={fade}
      show={show}
      autohide={autohide}
      className={classes}
      {...props}
    >
      {title && (
        <CToastHeader closeButton={showCloseButton}>
          {title}
        </CToastHeader>
      )}
      <CToastBody dangerouslySetInnerHTML={{
        __html: children,
      }} />
    </CToast>
  );
};
